import { Component, inject } from '@angular/core';
import { AuthService } from '../../../woo_services.module/AuthService';
import { User } from '../../../woo_services.module/shared-types';

@Component({
  selector: 'my-account',
  templateUrl: './my-account.component.html',
  standalone: false,
})
export class MyAccount {
  readonly authService = inject(AuthService);
  show = {
    passwordForm: false,
  };

  currentUser: User = this.authService.getUser();

  logout(): void {
    this.authService.logout();
  }
}
